module.exports = __webpack_public_path__ + "img/zoom.f9693615.jpg";